jQuery(function($) {
    // Do stuff

    function toggleSearch(e) {
        e.preventDefault();
        $('#site-search').toggleClass('open');
        $('.search-field').focus();
        // if ($('.menu-wrap').hasClass('menu-show')) {
        //   $('#nav-toggle').trigger('click');
        // }
    }

    $('#search-toggle, #search-close').click(function(e){
        toggleSearch(e);
    });




    // $('#search-toggle').on('click', function() {
    //     $( '#search-form' ).toggleClass( 'hidden' );
    //     $('html').toggleClass('site-background-active');
    //     $('#search-form .search-field').focus();
    // });

})



